import axios from 'axios';
import { urlCellPhone } from '../utils';

export const apiCellPhone = axios.create({
    baseURL: `${urlCellPhone}`
});